import { Injectable } from '@angular/core';

declare let userGuiding: any;

@Injectable({
  providedIn: 'root'
})
export class UserGuidingService {
  private isInitialized = false;

  constructor() {}

  /**
   * Initialize UserGuiding with your app ID
   * @param appId Your UserGuiding app ID
   */
  initUserGuiding(appId: string): void {
    if (this.isInitialized) {
      return;
    }

    try {
      // Use the exact UserGuiding script provided
      (function(g: any, u: any, i: any, d: any, e: any, s: any) {
        g[e] = g[e] || [];
        var f = u.getElementsByTagName(i)[0];
        var k = u.createElement(i);
        k.async = true;
        k.src = 'https://static.userguiding.com/media/user-guiding-' + s + '-embedded.js';
        f.parentNode.insertBefore(k, f);
        if (g[d]) return;
        var ug: any = g[d] = { q: [] };
        ug.c = function(n: any) {
          return function() {
            ug.q.push([n, arguments]);
          };
        };
        var m = ['previewGuide', 'finishPreview', 'track', 'identify', 'hideChecklist', 'launchChecklist'];
        for (var j = 0; j < m.length; j += 1) {
          ug[m[j]] = ug.c(m[j]);
        }
      })(window, document, 'script', 'userGuiding', 'userGuidingLayer', appId);

      this.isInitialized = true;
      console.log('UserGuiding initialized with app ID:', appId);
    } catch (error) {
      console.error('Error initializing UserGuiding:', error);
    }
  }

  /**
   * Identify a user for personalized experiences
   * @param userId Unique user identifier
   * @param userAttributes Optional user attributes
   */
  identifyUser(userId: string, userAttributes?: any): void {
    if (typeof userGuiding !== 'undefined') {
      userGuiding('identify', userId, userAttributes);
    }
  }

  /**
   * Track custom events
   * @param eventName Name of the event
   * @param eventProperties Optional event properties
   */
  trackEvent(eventName: string, eventProperties?: any): void {
    if (typeof userGuiding !== 'undefined') {
      userGuiding('track', eventName, eventProperties);
    }
  }

  /**
   * Start a specific guide
   * @param guideId The ID of the guide to start
   */
  startGuide(guideId: string): void {
    if (typeof userGuiding !== 'undefined') {
      userGuiding('startGuide', guideId);
    }
  }

  /**
   * Show or hide the UserGuiding launcher
   * @param show Whether to show the launcher
   */
  showLauncher(show: boolean): void {
    if (typeof userGuiding !== 'undefined') {
      userGuiding('showLauncher', show);
    }
  }

  /**
   * Update user attributes
   * @param attributes User attributes to update
   */
  updateUser(attributes: any): void {
    if (typeof userGuiding !== 'undefined') {
      userGuiding('updateUser', attributes);
    }
  }

  /**
   * Reset the user session
   */
  resetUser(): void {
    if (typeof userGuiding !== 'undefined') {
      userGuiding('reset');
    }
  }
}
